import { CatalogViewSection } from "@ext/catalog/views/components/Helpers/CatalogViewSection";
import { CatalogViewSectionDivider } from "@ext/catalog/views/components/Helpers/CatalogViewSectionDivider";
import { CatalogViewSectionHeader } from "@ext/catalog/views/components/Helpers/CatalogViewSectionHeader";
import { CatalogViewTag } from "@ext/catalog/views/components/Helpers/CatalogViewTag";
import { AddGrouping } from "@ext/catalog/views/components/Sections/EditCatalogView/CatalogViewGrouping/AddGrouping";
import { isHierarchyGrouping } from "@ext/catalog/views/logic/utils/resolveGroupBy";
import toggleGrouping from "@ext/catalog/views/logic/utils/toggleGrouping";
import t from "@ext/localization/locale/translate";
import PropertyServiceProvider from "@ext/properties/components/PropertyService";
import type { PropertyID } from "@ext/properties/models";
import { Label } from "@ui-kit/Label";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";
import { useCallback } from "react";

interface CatalogViewGroupingProps {
	groupBy: PropertyID[];
	disabled?: boolean;
	onChange: (groupBy: PropertyID[]) => void;
}

export const CatalogViewGrouping = ({ groupBy, disabled, onChange }: CatalogViewGroupingProps) => {
	const { properties: catalogProperties } = PropertyServiceProvider.value;
	const isHierarchy = isHierarchyGrouping(groupBy);

	const onRemove = useCallback((id: PropertyID) => onChange(toggleGrouping(groupBy, id)), [groupBy, onChange]);

	return (
		<>
			<CatalogViewSection>
				<CatalogViewSectionHeader>
					<Label>{t("catalog.views.sections.grouping")}</Label>
					<AddGrouping disabled={disabled} groupBy={groupBy} onChange={onChange} />
				</CatalogViewSectionHeader>
				<div className="flex flex-row flex-wrap items-center gap-1 pb-1">
					{isHierarchy ? (
						<CatalogViewTag state="active">
							<TextOverflowTooltip>{t("catalog.views.group-by-hierarchy")}</TextOverflowTooltip>
						</CatalogViewTag>
					) : (
						groupBy.map((id) => (
							<CatalogViewTag key={id} onClick={() => onRemove(id)} state="active">
								<TextOverflowTooltip>{catalogProperties.get(id)?.name ?? id}</TextOverflowTooltip>
							</CatalogViewTag>
						))
					)}
				</div>
			</CatalogViewSection>
			<CatalogViewSectionDivider />
		</>
	);
};
